import React, { createContext, useState, useCallback } from "react";
import PropTypes from "prop-types";

export const ModalContext = createContext({
    openModal: () => {},
    closeModal: () => {},
    isModalOpen: () => false,
});

export const ModalContextProvider = ({ children }) => {
    const [openModals, setOpenModals] = useState({});

    const openModal = useCallback((modalName) => {
        console.log(`✅ Opening modal: ${modalName}`);
        setOpenModals((prev) => ({ ...prev, [modalName]: true }));
    }, []);

    const closeModal = useCallback((modalName) => {
        console.log(`✅ Closing modal: ${modalName}`);
        setOpenModals((prev) => ({ ...prev, [modalName]: false }));
    }, []);

    const isModalOpen = useCallback(
        (modalName) => {
            return openModals[modalName] || false;
        },
        [openModals],
    );

    return (
        <ModalContext.Provider value={{ openModal, closeModal, isModalOpen }}>
            {children}
        </ModalContext.Provider>
    );
};

ModalContextProvider.propTypes = {
    children: PropTypes.node,
};
